var _desc, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 9601.0027 9601.0061",
    width: 9601.0029,
    height: 9601.0059,
    id: "svg8",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc1"
  }, "Sight_logo.dxf - scale = 25.400000, origin = (0.000000, 0.000000), method = file")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8",
    transform: "translate(4800.5016,3677.9833)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -1.5e-5,4242.5197 H -3203.7978 a 192,192 0 0 0 -133.4915,330 4800,4800 0 0 0 8133.1208,-3650.00002 192,192 0 0 0 -191.8332,-184 H 3312 a 192,192 0 0 0 -192,192 v 192.00002 a 3120,3120 0 0 1 -3120.000015,3120 z",
    style: {
      fill: "white",
      stroke: "#000000"
    },
    id: "path5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -4066.6325,3672.5197 a 192,192 0 0 0 162.6653,90 H 0 a 2640,2640 0 0 0 2640,-2640 V 930.51968 a 192,192 0 0 0 -192,-192 H 1152 a 192,192 0 0 0 -192,192 v 192.00002 a 960,960 0 0 1 -960,960 h -4461.6768 a 192,192 0 0 0 -185.9032,240 4800,4800 0 0 0 580.9475,1350 z",
    style: {
      fill: "white",
      stroke: "#000000"
    },
    id: "path6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -2640,1122.5197 v 192 a 192,192 0 0 0 192,192 h 1296 a 192,192 0 0 0 192,-192 v -192 A 960,960 0 0 1 0,162.51968 H 4461.6768 A 192,192 0 0 0 4647.58,-77.480315 4800,4800 0 0 0 4066.6325,-1427.4803 a 192,192 0 0 0 -162.6653,-90 H 0 a 2640,2640 0 0 0 -2640,2640 z",
    style: {
      fill: "white",
      stroke: "#000000"
    },
    id: "path7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.5e-5,-1997.4803 H 3203.7978 a 192,192 0 0 0 133.4915,-330 4800,4800 0 0 0 -8133.1208,3650 192,192 0 0 0 191.8332,184 H -3312 a 192,192 0 0 0 192,-192 v -192 a 3120,3120 0 0 1 3120.000015,-3120 z",
    style: {
      fill: "white",
      stroke: "#000000"
    },
    id: "path8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.04a1e32b6ebed74b9f5bdcb1251fe517.svg";
export { ForwardRef as ReactComponent };